import actionTypes from '../actionTypes';

export const requestAgentTransactionHistory = agentId => ({
  type: actionTypes.AGENT_TRANSACTION_HISTORY_REQUEST,
  agentId,
});

export const successAgentTransactionHistory = (agentId, data) => ({
  type: actionTypes.AGENT_TRANSACTION_HISTORY_SUCCESS,
  agentId,
  data,
});

export const failAgentTransactionHistory = (agentId, e) => ({
  type: actionTypes.AGENT_TRANSACTION_HISTORY_FAILURE,
  agentId,
  exception: e,
});

export const requestAgentTransaction = (from, to, amount, agentId) => ({
  type: actionTypes.AGENT_TRANSACTION_REQUEST,
  from,
  to,
  amount,
  agentId,
});
